const defaultState = {};

export const reducerType = 'formMirror';

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case `${reducerType}/SET_FORM_VALUES`: {
      const { formName, values } = action.payload || {};

      if (formName) {
        state = {
          ...state,
          [formName]: values || {}
        };
      }

      break;
    }

    case `${reducerType}/CLEAR_FORM_VALUES`: {
      const { formName } = action.payload || {};

      if (formName) {
        const nextState = { ...state };

        delete nextState[formName];
        state = nextState;
      }

      break;
    }

    // Cleanup on leaving the profile/creation flow. Replaces the old
    // redux-form destroy() of every USER_FORM_NAMES form.
    case 'user/CLEAR_PROFILE_FORM_DATA': {
      state = defaultState;

      break;
    }

    default: {
      break;
    }
  }

  return state;
}
